import {api} from 'api/setup';
import {ICustomerAddress} from 'types';

export const getCustomerAddresses = (): Promise<ICustomerAddress[]> => {
  return api.get('/customer-address');
};

export const createCustomerAddress = (newAddress: any): Promise<ICustomerAddress> => {
  return api.post('/customer-address', newAddress);
};

export const updateCustomerAddress = (addressId: number | string, newAddress: any): Promise<ICustomerAddress> => {
  return api.patch(`/customer-address/${addressId}`, newAddress);
};
